/**
 * A non-2xx answer from the API. `body` is the parsed response (the v3
 * validation envelope on a 422, `{ message }` on most others) so a caller can
 * read field errors without re-parsing.
 */
export class NewsdeskApiError extends Error {
  readonly status: number
  readonly body: unknown
  readonly url: string

  constructor({ status, body, url, message }: { status: number; body?: unknown; url: string; message?: string }) {
    super(message ?? NewsdeskApiError.describe(status, body, url))
    this.name = 'NewsdeskApiError'
    this.status = status
    this.body = body
    this.url = url
  }

  /** The API's own message when it sent one, else the status and the path. */
  static describe(status: number, body: unknown, url: string): string {
    const data = body as { message?: unknown; errors?: unknown } | null | undefined
    if (data && typeof data.message === 'string' && data.message) return data.message
    if (data && Array.isArray(data.errors) && data.errors.length) {
      const first = data.errors[0] as { detail?: unknown }
      if (first && typeof first.detail === 'string') return first.detail
    }
    return `NewsDesk API responded ${status} for ${url}`
  }

  /** Laravel's 422 shape: { message, errors: { 'filter.station_id': ['...'] } }. */
  get validationErrors(): Record<string, string[]> | null {
    const data = this.body as { errors?: unknown } | null | undefined
    if (this.status !== 422 || !data || typeof data.errors !== 'object' || data.errors === null || Array.isArray(data.errors)) return null
    return data.errors as Record<string, string[]>
  }
}
